import React from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip } from "chart.js";
import { Box, Stack, Typography } from "@mui/material";

ChartJS.register(ArcElement, Tooltip);

const COLORS = {
  Completed: "#16a34a",
  "In Progress": "#f97316",
  "Not Started": "#94a3b8",
};

const EMPTY_SEGMENTS = [
  { label: "Completed", value: 0 },
  { label: "In Progress", value: 0 },
  { label: "Not Started", value: 0 },
];

export default function WorksheetCompletionDonut({ data }) {
  const segments = data?.segments?.length ? data.segments : EMPTY_SEGMENTS;
  const total = segments.reduce((sum, s) => sum + (s.value || 0), 0);
  const completed = segments.find((s) => s.label === "Completed")?.value ?? 0;

  const chartData = {
    labels: segments.map((s) => s.label),
    datasets: [{
      data: segments.map((s) => s.value || 0),
      backgroundColor: segments.map((s) => COLORS[s.label] || "#cbd5e1"),
      borderWidth: 0,
    }],
  };

  return (
    <Stack direction={{ xs: "column", sm: "row" }} alignItems="center" spacing={2} sx={{ width: "100%" }}>
      <Box sx={{ position: "relative", width: 180, height: 180, flexShrink: 0 }}>
        <Doughnut
          data={chartData}
          options={{
            responsive: true,
            maintainAspectRatio: false,
            cutout: "70%",
            plugins: { legend: { display: false }, tooltip: { enabled: total > 0 } },
          }}
        />
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            pointerEvents: "none",
          }}
        >
          <Typography variant="h6" fontWeight={800} lineHeight={1.1} sx={{ color: "#111827" }}>
            {completed.toLocaleString('en-GB', { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' })}
          </Typography>
          <Typography variant="caption" sx={{ color: "#374151", fontWeight: 700 }}>Completed</Typography>
        </Box>
      </Box>
      <Stack spacing={1.25} sx={{ flex: 1, minWidth: 0 }}>
        {segments.map((seg) => {
          const value = seg.value || 0;
          const pct = total > 0 ? Math.round((value / total) * 100) : 0;
          return (
            <Stack key={seg.label} direction="row" alignItems="center" spacing={1}>
              <Box sx={{ width: 10, height: 10, borderRadius: "50%", bgcolor: COLORS[seg.label], flexShrink: 0 }} />
              <Typography variant="body2" sx={{ flex: 1, color: "#111827", fontWeight: 700 }} noWrap>{seg.label}</Typography>
              <Typography variant="body2" sx={{ color: "#374151" }} fontWeight={600} noWrap>
                {pct}% ({value.toLocaleString('en-GB', { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' })})
              </Typography>
            </Stack>
          );
        })}
      </Stack>
    </Stack>
  );
}
